export const STATUS_FILTER_DATA = [
  {
    label: 'Запланирована отправка',
    value: 'queued',
  },
  {
    label: 'Сообщение отправлено',
    value: 'sent',
  },
  {
    label: 'Ошибка при отправке',
    value: 'error',
  },
];

export const ACTION_FILTER_DATA = [
  {
    label: 'Записались',
    value: 'recorded',
  },
  {
    label: 'Ответили',
    value: 'answered',
  },
];
